module.exports = __webpack_public_path__ + "fonts/3b2641bd3a5fd19b8600aeb30bd9b8d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Quote/img/file_pdf_green.svg
// module id = 2008
// module chunks = 0